import { gql } from "@apollo/client";

export default gql`
  mutation markReportOnboardedMutation($reportId: Int!) {
    markReportOnboarded(reportId: $reportId) {
      user {
        id
        onboardingData
      }
    }
  }
`;
